import { durationLabel, formatWindowRange, getItemDuration } from 'utils/shortTerm'
// import { selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
// import { displayPrice } from 'utils/string'
import { /* Fragment, */ useState } from 'react'
// import { useSelector } from 'react-redux'
import { toLongDate } from 'utils/date'

const MagSection = ({ identifier, placeId, placeLocks, warehouseLocks, placeGps, placeAddress, noticePeriod, size, name, start, end, rentableType, rangeDate = {}, isShortTerm, startDateTime, endDateTime, durationMinutes }) => {
  const [isExpanded, expand] = useState(false)
  // const toPay = useSelector(selectBasketToPay)

  const { t, lang } = useTranslation('basket')
  // const renderItem = ({ text, price, depositAmount, type }, idx) => {
  //   return <Fragment key={idx}>
  //     <div className={type === 'discount' ? '--red' : undefined}>
  //       <span>{text}: </span>
  //       <span>{displayPrice(depositAmount ? (Number(price) - Number(depositAmount)) : price)}</span>
  //     </div>
  //     {depositAmount && <div className={type === 'discount' ? '--red' : undefined}>
  //       <span>{t('deposit')}: </span>
  //       <span>{displayPrice(depositAmount)}</span>
  //     </div>}
  //   </Fragment>
  // }

  const getRangeString = ({ m = 0, d = 0 }) => {
    if (m < 0) return t('forAnIndefinitePeriod')
    const getDays = () => `${d} ${t(d === 1 ? 'day' : 'days')}`
    const getMonths = () => `${m} ${t(m === 1 ? 'month' : m < 5 ? 'months<5' : 'months>=5')}`
    return !m ? getDays() : `${getMonths()}${d !== 0 ? ` i ${getDays()}` : ''}`
  }

  const thereArePlaceLocks = placeLocks && placeLocks.length > 0
  const thereAreWarehouseLocks = warehouseLocks && warehouseLocks.length > 0

  return (
    <div>
      <div className='list__header element__title'>{t(rentableType === 'parking' ? 'ParkingSpace' : rentableType === 'car' ? 'Vehicle' : 'Warehouse')}</div>
      <div className='list__element --big'>
        <div className='group'>
          <div className='element__title'>{name}</div>
          <i
            className='icon icon--help'
            onClick={() => {
              expand(e => !e)
            }}
          />
        </div>
        <div className={`hidableElement --${isExpanded ? 'visible' : 'hidden'}`}>
          <div className='element__desc'>
            {size?.area && <div>{t('area')}: {Number(size?.area)}m²</div>}
            {(size?.internalLength || size?.length) && <div>{t('length')}: {(size?.internalLength || size?.length)}m</div>}
            {(size?.internalWidth || size?.width) && <div>{t('width')}: {(size?.internalWidth || size?.width)}m</div>}
            {(size?.internalHeight || size?.height) && <div>{t('height')}: {(size?.internalHeight || size?.height)}m</div>}
          </div>
        </div>

        <div className='element__title'>{t('location')}</div>
        <div className='group'>
          {(placeGps && placeGps.length === 2)
            ? <div
              className='element__desc link'
              onClick={() => {
                window.open(`https://www.google.com/maps/search/?api=1&query=${placeGps[0]},${placeGps[1]}`)
              }}>
              <div>{placeAddress}</div>
            </div>
            : <div className='element__desc'>
              <div>{placeAddress}</div>
            </div>}
        </div>

        <div className='element__title'>{t('rentalTime')}</div>
        <div className='element__desc'>
          {isShortTerm
            ? <>
              <div>{durationLabel(getItemDuration({ startDateTime, durationMinutes, endDateTime }) || 0, lang)}</div>
              <div>{formatWindowRange(startDateTime, durationMinutes, endDateTime, lang)}</div>
            </>
            : <>
              <div>{getRangeString(rangeDate)}</div>
              <div>{toLongDate(start, lang)} → {end ? toLongDate(end, lang) : '∞'}</div>
            </>}
          {!isShortTerm && noticePeriod > 0 && <div>{t('noticePeriod')}: {noticePeriod} {t(noticePeriod === 1 ? 'day' : 'days')}</div>}
        </div>

        {(thereArePlaceLocks || thereAreWarehouseLocks) && <>
          <div className='element__title'>{t('typesOfOpening')}</div>
          <div className='element__desc'>
            {thereAreWarehouseLocks && <div>
              <span>{t('ofTheWarehouse')}: </span>
              {warehouseLocks.map(({ identifier: id, name }, idx) => <span key={id}>{idx > 0 ? ', ' : ''}{name}</span>)}
            </div>}
            {thereArePlaceLocks && <div>
              <span>{t('ofTheYard')}: </span>
              {placeLocks.map(({ identifier: id, name }, idx) => <span key={id}>{idx > 0 ? ', ' : ''}{name}</span>)}
            </div>}
          </div>
        </>}

        {/* <div className='element__title'>{t('costs')}</div>
        {toPay && <div className='element__desc'>
          {toPay[identifier]?.to_pay_without_addons?.list?.map(renderItem)}
          {toPay[identifier]?.to_pay_monthly?.list?.map(renderItem)}
        </div>} */}
      </div>
    </div>
  )
}

export default MagSection